module.exports = __webpack_public_path__ + "img/ic_ann.02697291.png";